import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const HeartLine = ()=>/*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12.7449 21.5022C12.3753 21.6326 11.7665 21.6326 11.3969 21.5022C8.24436 20.426 1.20007 15.9363 1.20007 8.32678C1.20007 4.9677 3.9069 2.25 7.24424 2.25C9.22273 2.25 10.9729 3.20663 12.0709 4.68506C13.1688 3.20663 14.9299 2.25 16.8975 2.25C20.2349 2.25 22.9417 4.9677 22.9417 8.32678C22.9417 15.9363 15.8974 20.426 12.7449 21.5022Z",
            stroke: "#282863",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
